import React, {useMemo, useRef, useEffect} from "react";
import {sanitizeSvg} from "./sanitizeSvg";

const MapSvg = ({svg, onMarkerClick}) => {
    const clean = useMemo(() => sanitizeSvg(svg), [svg]);
    const ref = useRef(null);

    useEffect(() => {
        const root = ref.current;
        if (!root) return;
        const handler = (e) => {
            const marker = e.target.closest(".turnstile-marker");
            if (!marker) return;
            const id = marker.getAttribute("data-turnstile-id");
            if (id != null) onMarkerClick(parseInt(id, 10));
        };
        root.addEventListener("click", handler);
        return () => root.removeEventListener("click", handler);
    }, [clean, onMarkerClick]);

    return (
        <div
            ref={ref}
            className="enigoo-map-svg"
            style={{
                width: "100%", height: "100%", overflow: "auto",
                borderRadius: 12, background: "#ffffff",
                // stejné tečkované plátno jako v editoru mapy
                backgroundImage: "radial-gradient(circle, #e1e2ed 1px, transparent 1px)",
                backgroundSize: "24px 24px",
            }}
            dangerouslySetInnerHTML={{__html: clean}}
        />
    );
};

export default MapSvg;
